import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemButton, ListItemIcon, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function RecipeReviewCard({imagen, tipoDeMedioDeComunicacion, listadoDeOpciones, handleClick, tipoDelMedio}) {

  return (
    <Grid item xs={12} sm={4} md={4}>
      <Card style={{ minWidth: '100%', width: '100%' }}>
        <img src={imagen} alt={imagen} style={{ width: 80, height: 80, display: "block", margin: '0 auto'}} />
        <CardContent>
          <Typography variant="h5" style={{textAlign: "center"}}> {tipoDeMedioDeComunicacion?.descripcion || ""} </Typography>
        </CardContent>
        <Collapse in={true} >
          <CardContent>
          <List>
            {listadoDeOpciones.map(({id, descripcion}) =>
              <ListItem key={id}>
                <ListItemButton onClick={() => handleClick(tipoDeMedioDeComunicacion, {id, descripcion}, tipoDelMedio)}>
                  <ListItemIcon> <ArrowForwardIosIcon /> </ListItemIcon> {descripcion}
                </ListItemButton>
              </ListItem>
            )}
          </List>
          </CardContent>
        </Collapse>
      </Card>
    </Grid>
  );
}


